import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

const EditPageAddEntity = ({
  entityName,
  onAdd,
}) => {
  return (
    <div className="edit-page__add-entity">
      <ButtonV2 onClick={onAdd}>Add {entityName}</ButtonV2>
    </div>
  )
}

EditPageAddEntity.propTypes = {
  entityName: PropTypes.string,
  onAdd: PropTypes.func,
};

export default EditPageAddEntity;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EditPageCommon/EditPageAddEntity.jsx